import { BadgeComposition } from './badge-composition.js';
import { appContext } from '../badge2.context.js';
import { nodeOffset } from '../utils/dom-utils.js';
import { $inject, $type } from '../utils/di-container.js';
import { FeatureService } from './feature.service.js';

/**
 * Manages badge compositions - an abstract layer defining what a badge is composed of and the options of each section
 * of the badge.
 */
export class BadgeCompositionService {

  /**
   * @private
   * @type {FeatureService}
   */
  _featureService;

  [$inject](obtain) {
    this._featureService = obtain(FeatureService);
  }

  newComposition(badge, component, ruleBuilder) {
    const { type, company, brands, product, debug, flavor } = badge;

    /** @type {_BadgeTypeOptions_PositionConfig} */
    let position = type.options.position;

    let badgeNodeOffset;
    if (component.base) {
      badgeNodeOffset = nodeOffset(component.base, true);
    }

    const config = {
      code: badge.toString(),
      debug,
      type,
      position,
      company,
      brands,
      product,
      badgeNodeOffset,
      maximized: (component.state || {}).isMaximized,
      flavor
    };

    const composition = new BadgeComposition(config);
    appContext.applyInject(composition);

    const rules = ruleBuilder(composition);
    return composition.execute(rules);
  }

}

BadgeCompositionService[$type] = Symbol('BadgeCompositionService');
